import firebaseApp from '../../utils/firebase'

export default {
  jsPostData({ getters }, post) {

    const sid = getters.bindSID

    if (!sid)
      return null

    return firebaseApp.ref.child('messages')
      .child(sid)
      .child('data')
      .push({
        from: getters.getOrgId,
        created_at: firebaseApp.TIMESTAMP,
        ...post
      })
      .key

  },
  jsPostMessage({ getters, dispatch }, post) {

    let meta = getters.getUser || {}
    let message = post.message

    if (!message)
      return null

    for (var i in meta)
      if (meta[i])
        message = message.replace('{'+i+'}', meta[i])

    post.message = message.replace(/{.+}/g,'').replace(' ,',',')

    dispatch('jsPostData', {
      type: 3,
      ...post
    })

  }
}
